var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHalfCheckBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#2175D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.962 11c.573 0 1.038.448 1.038 1 0 .52-.412.947-.938.995l-.1.005H7.038C6.465 13 6 12.552 6 12c0-.52.412-.947.938-.995l.1-.005h9.924z",
    fill: "#FFF"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiByeD0iNCIgZmlsbD0iIzIxNzVEOSIvPgogICAgICAgIDxwYXRoIGQ9Ik0xNi45NjIgMTFjLjU3MyAwIDEuMDM4LjQ0OCAxLjAzOCAxIDAgLjUyLS40MTIuOTQ3LS45MzguOTk1bC0uMS4wMDVINy4wMzhDNi40NjUgMTMgNiAxMi41NTIgNiAxMmMwLS41Mi40MTItLjk0Ny45MzgtLjk5NWwuMS0uMDA1aDkuOTI0eiIgZmlsbD0iI0ZGRiIvPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgHalfCheckBox as ReactComponent };